import { yupResolver } from '@hookform/resolvers/yup';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { BulkEditDrawerDataType } from './bulk-edit-drawer.component';

export const useBulkEditDrawer = () => useDrawer<BulkEditDrawerDataType>();

export const useBulkEditForm = (props: BulkEditDrawerDataType | undefined) => {
  const schema = useMemo(() => {
    return props?.bulkEdit?.fields[props?.column?.field]?.schema;
  }, [props?.bulkEdit?.fields, props?.column?.field]);

  const form = useForm({
    resolver: schema ? yupResolver(schema) : undefined,
    defaultValues: schema?.cast(props?.defaultValues),
  });

  useEffect(() => {
    if (schema) form.reset(schema.cast(props?.defaultValues));
  }, [schema, form, props?.defaultValues]);

  return form;
};
